"use client";
import Div from "@jumbo/shared/Div";
import EditIcon from "@mui/icons-material/Edit";
import {
  Card,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  styled,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

const Item = styled(Div)(({ theme }) => ({
  padding: theme.spacing(0, 1),
}));

const EmployeesListItem = ({ item }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { clientId } = useParams();
  return (
    <Card sx={{ mb: 1 }}>
      <Stack
        direction={"row"}
        alignItems={"center"}
        sx={{ p: (theme) => theme.spacing(2, 1) }}
      >
        <Item
          sx={{
            flex: { xs: 1, md: "0 1 45%", lg: "10 1 35%" },
          }}
        >
          <Stack direction={"row"} alignItems={"center"}>
            <Div
              sx={{
                flex: { xs: "0 1 auto", md: 2 },
                display: { xs: "none", md: "block" },
                flexShrink: 0,
                px: 1,
              }}
            >
              <Typography
                fontSize={"12px"}
                variant={"h6"}
                color={"text.secondary"}
                mb={0.25}
                sx={{
                  display: { xs: "none", md: "block" },
                }}
              >
                {t("pages.dsokCustomers.employees.firstName")}
              </Typography>
              <Typography variant={"body1"}>
                {item.firstName} {item.lastName}
              </Typography>
            </Div>
            <Div
              sx={{
                flex: { xs: "0 1 auto", md: 2 },
                display: { xs: "none", md: "block" },
                flexShrink: 0,
                px: 1,
              }}
            >
              <Typography
                fontSize={"12px"}
                variant={"h6"}
                color={"text.secondary"}
                mb={0.25}
                sx={{
                  display: { xs: "none", md: "block" },
                }}
              >
                {t("pages.dsokCustomers.status")}
              </Typography>
              <Typography variant={"body1"}>
                {item.active
                  ? t("pages.dsokCustomers.active")
                  : t("pages.dsokCustomers.inactive")}
              </Typography>
            </Div>
            <Div
              sx={{
                flex: { xs: "0 1 auto", md: 2 },
                display: { xs: "none", md: "block" },
                flexShrink: 0,
                px: 1,
              }}
            >
              <Typography
                fontSize={"12px"}
                variant={"h6"}
                color={"text.secondary"}
                mb={0.25}
                sx={{
                  display: { xs: "none", md: "block" },
                }}
              >
                {t("pages.dsokCustomers.employees.email")}
              </Typography>
              <Typography variant={"body1"}>{item.email}</Typography>
            </Div>
            <Div
              sx={{
                flex: { xs: "0 1 auto", md: 2 },
                display: { xs: "none", md: "block" },
                flexShrink: 0,
                px: 1,
              }}
            >
              <Typography
                fontSize={"12px"}
                variant={"h6"}
                color={"text.secondary"}
                mb={0.25}
                sx={{
                  display: { xs: "none", md: "block" },
                }}
              >
                {t("pages.dsokCustomers.employees.phone")}
              </Typography>
              <Typography variant={"body1"}>{item.phone}</Typography>
            </Div>
            <Div
              sx={{
                flex: { xs: "0 1 auto", md: 2 },
                display: { xs: "none", md: "block" },
                flexShrink: 0,
                px: 1,
              }}
            >
              <Typography
                fontSize={"12px"}
                variant={"h6"}
                color={"text.secondary"}
                mb={0.25}
                sx={{
                  display: { xs: "none", md: "block" },
                }}
              >
                {t("pages.dsokCustomers.employees.pinCode")}
              </Typography>
              <Typography variant={"body1"}>{item.pinCode}</Typography>
            </Div>
            <Div
              sx={{
                flex: { xs: "0 2 auto", md: 1 },
                px: 1,
              }}
            >
              <Typography
                fontSize={"12px"}
                variant={"h6"}
                color={"text.secondary"}
                mb={0.25}
                sx={{
                  display: { xs: "none", md: "block" },
                }}
              >
                {t("pages.presentation.actions")}
              </Typography>
              <Div
                sx={{
                  display: "flex",
                  flex: { direction: "row", flexWrap: "wrap" },
                  minWidth: 110,
                }}
              >
                <Div>
                  <IconButton
                    size="small"
                    variant={"contained"}
                    onClick={() => {}}
                  >
                    <Tooltip
                      title={t("buttons.edit")}
                      placement="top-start"
                      onClick={() => {
                        navigate(
                          `/customer/dsok/clients/${clientId}/employees/${item?.employeeId}`
                        );
                      }}
                    >
                      <EditIcon />
                    </Tooltip>
                  </IconButton>
                </Div>
              </Div>
            </Div>
          </Stack>
        </Item>
      </Stack>
    </Card>
  );
};

export default EmployeesListItem;
